import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MasterInformationService } from '../../Services/master-information.service';
import { apiEndPoints } from '../../api/apiEndPoint';

@Component({
  selector: 'app-account-deletion',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgbModalModule, ToastrModule],
  templateUrl: './account-deletion.component.html',
  styleUrl: './account-deletion.component.css'
})
export class AccountDeletionComponent {

  deletionForm: FormGroup;

  constructor(private fb: FormBuilder,
    private masterService: MasterInformationService, private modalService: NgbModal, private toastr: ToastrService) {
    this.deletionForm = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]]
    });
  }

  ngOnInit(): void {

  }

  get phoneNumber() {
    return this.deletionForm.get('phoneNumber');
  }

  // ------------------------------ Modal Open ------------------------------ //

  openConfirmationModal(content: any) {
    this.modalService.open(content, { centered: true });
  }

  // ------------------------------ Account Deletion API ------------------------------ //

  onSubmit() {
    if (this.deletionForm.valid) {
      const phoneNumber = this.deletionForm.value.phoneNumber;
      const status = true;

      const reqBody = {
        phoneNumber: phoneNumber,
        status: status ? false : true
      };

      this.masterService.accountDelete(apiEndPoints.userDelete, reqBody).subscribe({
        next: (response: any) => {
          if (response.statusText == 'Successfull') {
            this.toastr.success('Account Deleted Successfully', 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
          }
          else {
            this.toastr.warning('Number not exist', 'Warning', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true
            });
          }
        }
      })

    }

  }

  // ------------------------------ Number Handling ------------------------------ //

  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  limitToTenDigits(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, '').slice(0, 10);
    this.deletionForm.get('phoneNumber')?.setValue(input.value);
  }
}
